// /src/store/tasksManagment/actions.ts

import { Dispatch } from 'redux';
import { RootState } from '../generalReducer';

import {
  UPSERT_TRANSCODING_TASK,
  REMOVE_TRANSCODING_TASK,
  TasksActionTypes,
  TranscodingTaskState,
  TranscodingTaskStatus,
} from './types';

// Une seule action pour créer OU mettre à jour une tâche de transcodage : le
// reducer distingue déjà les deux cas par la présence du mediaId, comme pour
// un upsert en base.
export const upsertTranscodingTask = (
  mediaId : number,
  label   : string,
  progress: number,
  status  : TranscodingTaskStatus,
) => (dispatch: Dispatch<TasksActionTypes>) => {
  dispatch({
    type: UPSERT_TRANSCODING_TASK,
    payload: { mediaId, label, progress, status },
  });
};

export const removeTranscodingTask = (mediaId: number) => (dispatch: Dispatch<TasksActionTypes>) => {
  dispatch({
    type: REMOVE_TRANSCODING_TASK,
    payload: { mediaId },
  });
};

export const getAllTranscodingTasks = (state: RootState): TranscodingTaskState[] =>
  Object.values(state.tasksReducer.transcodingTasks);

export const getActiveTranscodingTasks = (state: RootState): TranscodingTaskState[] =>
  Object.values(state.tasksReducer.transcodingTasks).filter(
    t => t.status === TranscodingTaskStatus.TRANSCODING
  );
